/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 11:42:30
 * @FilePath: /rongxin.web/src/views/home/product-service/index.js
 */
import Service from './servece.js';
export default {
  data() {
    return {
      params: {
        limit: '10',
        homePage: 1, // 只要首页推荐且已发布的数据
        status: 1,
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '6188e64fc2d92675c94f559b',
        source: 'guanWang'
      },
      control: 'controls',
      newsArr: []
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      Service.getNewsList(this.params).then(data => {
        this.newsArr = data.data && data.data.list.slice(0, 3);
      });
    },
    // 二级页面
    goMidea() {
      this.$router.push({path: 'mediaReportsDetail'});
    },
    // 媒体详情
    goMediaReportsDetail(paths, id) {
      this.$router.push({
        path: paths,
        query: {
          id: id
        }
      });
    }
  }
};
